import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'applicants',
            name: 'applicant',
            class: 'Modules\\Applicant\\Entities\\Applicant',

            postcode: null,
            newPostcode: null,
            showPostcodesDialog: false,
            loadingPostcode: false,
            handlerPostcode: null,

            email: null,
            showApplicantDialog: false,
            loadingApplicant: false
        }
    },

    methods: {
        openPostcodesDialog(handlerPostcode = null) {
            this.handlerPostcode = handlerPostcode
            this.showPostcodesDialog = true
        },

        hidePostcodesDialog() {
            this.showPostcodesDialog = false
        },

        isAMP() {
            this.loadingPostcode = true

            axios({
                method: 'post',
                url: route('api.site.is.amp'),
                data: {
                    postcode: this.newPostcode
                },
            })
            .then(response => {
                if(response.data.is_amp) {
                    this.$cookie.set('postcode', this.newPostcode)

                    this.postcode = this.newPostcode

                    this.hidePostcodesDialog()

                    if(typeof this.handlerPostcode == 'function') {
                        this.handlerPostcode()
                    }
                } else {
                    this.$cookie.set('postcode', null)
        
                    this.postcode = null

                    this.openApplicantDialog()
                }
            })
            .catch(
                error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
            )
            .finally(
                () => this.loadingPostcode = false
            )
        },

        openApplicantDialog() {
            this.hidePostcodesDialog()

            this.showApplicantDialog = true
        },

        hideApplicantDialog() {
            this.showApplicantDialog = false
        },

        newApplicant() {
            this.loadingApplicant = true

            axios({
                method: 'post',
                url: route('api.applicants.subscribe'),
                data: {
                    postcode: this.newPostcode,
                    email: this.email
                },
            })
            .then(response => {
                this.$alert('Gracias por confiar en nosotros, en breve nos pondremos en contacto con usted', 'Listo!', 'success')

                this.hideApplicantDialog()
            })
            .catch(
                error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')
            )
            .finally(
                () => this.loadingApplicant = false
            )
        }
    },

    created() {
        const postcode = this.$cookie.get('postcode')

        if(postcode && postcode != 'null') {
            this.postcode = postcode
        }
    }
}